import $ from 'jquery'
import 'slick-carousel'

export const renderSliderFullMagazine = (slider) => {
  const hideDots = function ($slides, $dots) {
    if ($slides.length === 1) {
      $dots.hide()
    }
  }
  $('.slider-full-magazine-container', slider).slick({
    rows: 0,
    arrows: true,
    dots: true,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: false,
    centerMode: false,
    swipeToSlide: true,
    speed: 300,
    centerPadding: '10px',
    accessibility: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false,
          swipeToSlide: false,
          accessibility: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false,
          swipeToSlide: false,
          accessibility: false,
        },
      },
    ],
  }).on('breakpoint', function () {
    hideDots($(this).find('.slick-slide'), $(this).find('.slick-dots'))
  })
  hideDots($('.slick-slide', slider), $('.slick-dots', slider))
}
